import * as React from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import Typography from '@mui/joy/Typography';

const LeadershipCard = (data) => {
    const image = data.image;
    const name = data.name;
    const title = data.title;

    return (
        <Card variant="outlined" sx={{ width: '20rem' }}>
            <CardOverflow>
                <AspectRatio ratio="1">
                    <img
                        src={image}
                        srcSet="https://images.unsplash.com/photo-1532614338840-ab30cf10ed36?auto=format&fit=crop&w=318&dpr=2 2x"
                        loading="lazy"
                        alt={name}
                    />
                </AspectRatio>
            </CardOverflow>
            <CardContent>
                <Typography level="title-md">{name}</Typography>
                <Typography level="body-sm">{title}</Typography>
            </CardContent>
        </Card>
    );
}

export default LeadershipCard